import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { customPackage } from "../services/http-service/customPackage";

export const useCustomPackage = ({ enabled }: { enabled: boolean }) => {
  const {
    isLoading: loadingCustomPackage,
    isFetching: fetchingCustomPackage,
    isError: errorFetchingCustomPackage,
    data: CustomPackageResponse,
    error: errorCustomPackageResponse,
    refetch: refetchCustomPackage,
  } = useQuery({
    queryKey: ["customPackage"],
    queryFn: async () => await customPackage(),
    enabled: enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
    staleTime: 0,
    cacheTime: 0,
  });
  const fetchCustomPackageError = (errorCustomPackageResponse as AxiosError)?.response?.data;

  return {
    loadingCustomPackage,
    fetchingCustomPackage,
    errorFetchingCustomPackage,
    CustomPackageResponse,
    fetchCustomPackageError,
    refetchCustomPackage,
  };
};
